import { styles } from './styles';

import { Page, Text, View, Document, Font } from '@react-pdf/renderer';
import OpenSans from 'fonts/open-sans/OpenSans-Regular.ttf';
import { Alert } from 'react-bootstrap';
import { translations } from './translations';
import BrandSection from './components/BrandSection';
import CustomerDetailsSection from './components/CustomerDetailsSection';
import DateSection from './components/DateSection';
import ProductDetailsHeaderSection from './components/ProductDetailsHeaderSection';
import ProductDetailsItem from './components/ProductDetailsItem';
import OrderSummarySection from './components/OrderSummarySection';
import PaymentDetailsSection from './components/PaymentDetailsSection';

const OrderPDFDocument = ({
  order,
  balances,
  products,
  customer,
  user,
  images,
  isPriceless,
  lang,
  currency,
}) => {
  // Font Registration
  Font.register({
    family: 'Open Sans',
    src: OpenSans,
  });

  const PDFDoc = () => (
    <Document>
      <Page size="A4" style={styles.body} wrap={false}>
        {/* Header */}
        <View style={styles.headerContainer}>
          <BrandSection />
          <View style={styles.headerBlankView}>
            <Text></Text>
          </View>
          <CustomerDetailsSection customer={customer} translations={translations} lang={lang} />
        </View>

        {/* Date */}
        <DateSection order={order} translations={translations} lang={lang} />

        {/* Order Details */}
        <View style={styles.tableContainer}>
          <ProductDetailsHeaderSection
            isPriceless={isPriceless}
            translations={translations}
            lang={lang}
          />

          {products.length > 0 &&
            products.map((product, index) => {
              return (
                <ProductDetailsItem
                  key={`product-details-item-${index}`}
                  product={product}
                  index={index}
                  images={images}
                  isPriceless={isPriceless}
                  translations={translations}
                  lang={lang}
                  currency={currency}
                />
              );
            })}
          {/* Order Summary */}
          {products.length > 0 && (
            <OrderSummarySection
              isPriceless={isPriceless}
              order={order}
              translations={translations}
              lang={lang}
              currency={currency}
            />
          )}
        </View>

        {/* Payment Details */}
        {!isPriceless && (
          <PaymentDetailsSection
            balances={balances}
            user={user}
            translations={translations}
            lang={lang}
            currency={currency}
          />
        )}

        {/* Footer */}
        {/* <Text style={styles.footerText}>{translations.sincerely[lang]},</Text> */}

        <Text style={styles.pageNumber} fixed>
          {translations.warning[lang]}
        </Text>
      </Page>
    </Document>
  );

  return order ? (
    <PDFDoc />
  ) : (
    <Alert variant="danger">Sipariş Bulunamadığı için PDF Oluşturulamadı!!!</Alert>
  );
};

export default OrderPDFDocument;
